import { VehicleInterface } from "."

interface elementsInterface {
    label: string,
    gridArea: string,
    field: keyof VehicleInterface
}

export const elements: elementsInterface[] = [
    {
        label: 'Placa',
        gridArea: 'plate',
        field: 'plate'
    },
    {
        label: 'Modelo',
        gridArea: 'model',
        field: 'model'
    },
    {
        label: 'Ano',
        gridArea: 'year',
        field: 'year'
    },
    {
        label: 'Capacidade',
        gridArea: 'capacity',
        field: 'capacity'
    },
    {
        label: 'Tamanho da carroceria',
        gridArea: 'bodyWork',
        field: 'size'
    },
    {
        label: 'Restição de rodagem',
        gridArea: 'restrictions',
        field: 'restriction'
    },
]